import { useQuery } from "react-query";
import { sureApiCall } from "src/api/axiosClient/sureApi";

// Interface for locale data from Sure API
export interface Locale {
    id: number;
    code: string;
    name: string;
    nativeName?: string;
    flag?: string;
    direction: string;
    isDefault: boolean;
}

// Sure API response structure
interface LocalesResponse {
    "hydra:member": Locale[];
    "hydra:totalItems": number;
}

export const useLocales = () => {
    const fetchLocales = async (): Promise<Locale[]> => {
        // Try with itemsPerPage first for better results
        let response: any;
        try {
            response = await sureApiCall.get<LocalesResponse>("/api/locales", {
                params: {
                    itemsPerPage: 100,
                },
            });
        } catch {
            response = await sureApiCall.get<LocalesResponse>("/api/locales");
        }

        const locales = response.data["hydra:member"] || [];
        return locales;
    };

    const query = useQuery({
        queryKey: ["locales"],
        queryFn: fetchLocales,
        retry: 2,
        staleTime: 24 * 60 * 60 * 1000, // 1 day - locales don't change often
    });

    return {
        locales: query.data ?? [],
        isLoading: query.isLoading,
        error: query.error,
        refetch: query.refetch,
    };
};
